import React, { useCallback } from "react";
import { useFormField } from "state/hooks/useFormField";
import { useFormContext } from "playground/cms/Form";
import Button from "components/Button";
import { CronScheduleEditor } from "./CronScheduleEditor";

export function CronForm({ onClose }) {
    const { value: cronSchedule, onChange: setCronSchedule } =
        useFormField("cron_schedule");
    const { onSave } = useFormContext();

    const handleSave = useCallback(() => {
        onSave();
        onClose();
    }, [onSave, onClose]);

    return (
        <div className={"cron-item-edit rows gap-sm"}>
            <CronScheduleEditor
                value={cronSchedule}
                onChange={setCronSchedule}
            />
            <div className={"cols gap-sm"}>
                <Button size={"small"} onClick={handleSave}>
                    Zapisz
                </Button>
                <Button size={"small"} variant={"text"} onClick={onClose}>
                    Anuluj
                </Button>
            </div>
        </div>
    );
}

CronForm.defaultProps = {};

export default CronForm;